define('view/people/people.left.nav',['require','exports','module','underscore','uikit/uikit','backbone.radio','fukit/fukit','blockit','fukit/fukit'],function(require, exports, module) {
  // prettier-ignore
  var _ = require('underscore'),
      UIKit = require('uikit/uikit'),
      Radio = require('backbone.radio'),
      ROLES = require('fukit/fukit').Roles,
      BlocKit = require('blockit'),
      AuthorizationBehavior = require('fukit/fukit').AuthorizationBehavior;

  const BASE_REACT_ROUTE = '/admin-web';
  function getReactRoute (route){ return BASE_REACT_ROUTE + route};

  var PeopleLeftNav = UIKit.Menu.extend({
    options: _.extend({}, UIKit.Menu.prototype.options, {
      direction: 'left',
      vertical: true,
      fluid: true,
      items: [
        {
          text: 'Name',
          link: getReactRoute('/profile'),
        },
        {
          text: 'Contact Info',
          link: getReactRoute('/profile/contact'),
        },
        {
          text: 'Internal Associations',
          link: getReactRoute('/profile/internalassociations'),
        },
        {
          text: 'External Associations',
          link: getReactRoute('/profile/externalassociations'),
        },
        {
          text: 'User Account & Roles',
          link: getReactRoute('/profile/roles'),
        },
        {
          text: 'Trainings & Certifications',
          link: getReactRoute('/profile/trainings'),
        },
        {
          text: 'Documents',
          link: getReactRoute('/profile/documents'),
        },
        {
          text: 'COI Disclosures',
          link: '#disclosures',
          behaviors: {
            hideItemIfAppInactive: {
              behaviorClass: BlocKit.BindAndFormatOptionValuesBehavior,
              optionValues: {
                visible: {
                  formatter: function(model) {
                    var enabledProductCollection = Radio.request(
                        'AppKit.resourceService',
                        'resource',
                        'enabledProductCollection'
                    );
                    var coiModel;

                    if (!_.isUndefined(enabledProductCollection)) {
                      coiModel = enabledProductCollection.findWhere({ name: 'COI', active: true });
                      const dataModel = coiModel.collection.models;
                      const filteredDataArray = dataModel.filter(function (item) {
                        return item.attributes.name === "COI" && item.attributes.active === true;
                      });
                      const productNewCoiUiValue = filteredDataArray[0].attributes.productNewCoiUi;
                      localStorage.setItem("productNewCoiUiValue", productNewCoiUiValue.toString());
                    }

                    return !_.isUndefined(coiModel);
                  },
                },
              },
            },
            authorizationBehavior: {
              visibleOnlyWhen: [
                {
                  filter: function() {
                    return true;
                  },
                  roles: [ROLES.COI_DISCLOSEE_WEB_ACCESS],
                },
              ],
              behaviorClass: BlocKit.AuthorizationBehavior,
            },
          },
        },
      ],
    }),

    initialize: function() {
      UIKit.Menu.prototype.initialize.apply(this, arguments);

      this.processItems();

      this.on('childview:change:link', function(view) {
        if (location.href.indexOf(view.link) != -1) {
          view.$el.addClass('active');
        } else if (location.hash === '' && view.link === '#name') {
          view.$el.addClass('active');
        }
      });
    },

    processItems: function() {
      var items = this.getOption('items');

      this.menuItemViewArray = UIKit.Menu.createMenuItems(items);
      this.addAll(this.menuItemViewArray);
    },
  });

  module.exports = PeopleLeftNav;
});

